import { render, staticRenderFns } from "./rewritelogs.vue?vue&type=template&id=04fa6e64&scoped=true&"
import script from "./rewritelogs.vue?vue&type=script&lang=js&"
export * from "./rewritelogs.vue?vue&type=script&lang=js&"
import style0 from "./rewritelogs.vue?vue&type=style&index=0&id=04fa6e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fa6e64",
  null
  
)

export default component.exports